import { z } from 'zod';

import type { ActivityDefinition } from './types.js';

import { trimmed } from './_checks.js';
import { draftFields } from './_shared.js';
import { activityIssue, asList, asRecord } from './types.js';

const issue = activityIssue('acknowledgement_checklist');

export const AcknowledgementChecklistItem = z.looseObject({
  text: z.string().optional(),
});

/** Lines the player has to tick before moving on, under an optional intro. */
export const acknowledgementChecklist: ActivityDefinition = {
  type: 'acknowledgement_checklist',
  summary: 'A checklist the player has to tick every line of before moving on.',
  setup: z.looseObject({
    ...draftFields,
    intro: z.string().optional(),
    items: z.array(AcknowledgementChecklistItem).optional(),
  }),
  check: (setup, ctx) => {
    const items = asList(setup.items);
    if (!items.length) {
      return [issue('empty', 'No items are written — there is nothing to acknowledge.', [...ctx.path, 'setup', 'items'], ctx)];
    }

    const issues = [];
    for (const [index, raw] of items.entries()) {
      if (!trimmed(asRecord(raw).text)) {
        issues.push(issue('itemText', `Item ${index + 1} has no text to tick.`, [...ctx.path, 'setup', 'items', index, 'text'], ctx, raw));
      }
    }
    return issues;
  },
};
